import {
    Component,
    OnInit,
    HostBinding,
    HostListener,
    OnDestroy
} from '@angular/core';
import {
    Router
} from '@angular/router';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { tap, map, takeUntil, filter, combineLatest } from 'rxjs/operators';

import { MenuService } from '../menu.service';
import { SessionService } from '../../session.service';

import { SeasonsService } from '../../enter.module/seasons.service';

const IS_NW = 'isNw';
const IS_NOT_NW = 'isNotNw';
const IS_PTR = 'isPtr';
const IS_NOT_PTR = 'isNotPtr';
const IS_SEASON_ACCESS_GRANTED = 'isSeasonAccessGranted';
const IS_NOT_SEASON_ACCESS_GRANTED = 'isNotSeasonAccessGranted';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.pug',
    styleUrls: ['./menu.component.less']
})
export class MenuComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    @HostBinding('class.--ui') _ui = true;
    @HostBinding('class.--visible') visible: boolean = false;

    _validatorsSbj: BehaviorSubject<any> = new BehaviorSubject({
        [IS_NW]: () => !!window.nw,
        [IS_NOT_NW]: () => !window.nw,
        [IS_PTR]: () => window.CONFIG.IS_PTR,
        [IS_NOT_PTR]: () => !window.CONFIG.IS_PTR,
        [IS_SEASON_ACCESS_GRANTED]: () => false,
        [IS_NOT_SEASON_ACCESS_GRANTED]: () => true
    });

    menuData$: Observable<any[]>;
    menuSettings: any = {};

    dot$: Observable<any> = this._menuSrv.dot$;
    badge$: Observable<any> = this._menuSrv.badge$;
    attention$: Observable<any> = this._menuSrv.attention$;

    @HostListener('click', ['$event'])
    onClick() {
        this.hide();
    }

    constructor(
        private _router: Router,

        private _menuSrv: MenuService,
        private _sessionSrv: SessionService,
        private _seasonsSrv: SeasonsService
    ) {
        this._menuSrv.visible$
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((visible) => this.visible = visible))
            .subscribe();

        const docClickHandler = () => {
            setTimeout(() => this.hide());
        };
        this._menuSrv.visible$
            .pipe(takeUntil(this._destroySbj))
            .pipe(filter((visible) => visible))
            .pipe(tap(() => {
                document.removeEventListener('click', docClickHandler);
                setTimeout(() => document.addEventListener('click', docClickHandler, true));
            }))
            .subscribe();

        this._menuSrv.visible$
            .pipe(takeUntil(this._destroySbj))
            .pipe(filter((visible) => !visible))
            .pipe(tap(() => {
                document.removeEventListener('click', docClickHandler, true);
            }))
            .subscribe();

        this._menuSrv.settings$
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((settings) => this.menuSettings = settings))
            .subscribe();

        this.menuData$ = this._menuSrv.data$
            .pipe(combineLatest(this._validatorsSbj))
            .pipe(map(([menuData, validators]) => {
                return menuData.map((data) => ({
                    ...data,
                    items: data.items.filter(({ conditions }, idx) => {
                        return !conditions || !conditions.some((condition) => {
                            if (!validators[condition]) {
                                return false;
                            }

                            return !validators[condition]();
                        });
                    })
                }));
            }));
    }

    async ngOnInit() {
        this._seasonsSrv.accessGranted$
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((access) => {
                this._validatorsSbj.next({
                    ...this._validatorsSbj.getValue(),
        
                    [IS_SEASON_ACCESS_GRANTED]: () => access,
                    [IS_NOT_SEASON_ACCESS_GRANTED]: () => !access
                });
            }))
            .subscribe();
    }

    ngOnDestroy() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    hide() {
        this._menuSrv.hide();
    }

    show() {
        setTimeout(() => this._menuSrv.show());
    }

    async reconfig(item: IMenuItem) {
        if (item.versionData) {
            this._sessionSrv.initSessionServer({
                name: 'Seasonal server',

                apiUrl: item.config.API_URL,
                websocketUrl: item.config.WEBSOCKET_URL,
                prefix: '',

                settings: {
                    official: true,
                    host: 'screeps.com/season',
                    port: ''
                },

                users: null
            }, item.versionData);
        }

        if (item.redirectUrl) {
            this._router.navigate([item.redirectUrl]);
        }
    }

    emit(item: IMenuItem) {
        this._menuSrv.emit(item);
    }
}
